(function () {

    'use strict';

    angular.module('app.vehicledetails', []);

})();




// WEBPACK FOOTER //
// ./app/vehicledetails/vehicledetails.module.js